const initialState = {
  dialogs: []
}

function addDialog (state, action) {
  state.dialogs.push({
    id: action.id,
    state: {
      show: true,
      content: action.content,
      maxWidth: action.maxWidth,
      showPrint: action.showPrint,
      confirmCallback: action.confirmCallback,
      cancelCallback: action.cancelCallback
    }
  })
  state.dialogs = state.dialogs.slice(0)
}

function closeDialog (state, action) {
  if (action.id) {
    for (let i = state.dialogs.length; i--;) {
      if (state.dialogs[i].id === action.id) { state.dialogs.splice(i, 1) }
    }
    state.dialogs = state.dialogs.slice(0)
  } else { state.dialogs = [] }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'OPEN_DIALOG':
      addDialog(state, action)
      return { ...state }
    case 'CLOSE_DIALOG':
      closeDialog(state, action)
      return { ...state }
    default:
      return { ...state }
  }
}
